import axios from "axios";
import config from "@/config/constants";
import store from "../store";
import { getServices } from "../../api";
import { getCoachingData } from "@/utils/coachingUtils";

//handling client handover by extracting the token and base_64 encoded redirect_url if it exists
export async function handleHandover({ to, from, next }) {
  try {
    const payload = {
      security_token: to.query.token
    };
    let response = await axios.post(
      config.api_env + "/application/api/u/auth/get-access-token",
      payload,
      config.options
    );
    if (response.data.authenticated) {
      store.commit("setIsRedirection", true);
      store.commit("setUser", response.data);
      store.commit("setInitialCourseProgress");
      store.commit("setLanguage", response.data.lang);
      await getServices();
    }
    const { token, ...restQuery } = to.query;
    if (
      to.path === "/session-booking" &&
      to.query.service_id &&
      (to.query.service_id === "slm" || to.query.service_id === "mhc")
    ) {
      const { hasCoach } = await getCoachingData();
      if (hasCoach) {
        next({
          path: "/coaching-platform",
          query: restQuery
        });
        return;
      }
    }
    next({
      path: to.path,
      query: restQuery
    });
  } catch (e) {
    console.error(e);
  }
}